import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useController } from 'react-hook-form';
import InputElement from 'react-input-mask';
import styles from './RentalFormTextField.scss';

const propTypes = {
  label: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  required: PropTypes.bool,
  type: PropTypes.oneOf([
    'text',
    'phone',
  ]),
};

const defaultProps = {
  required: undefined,
  type: 'text',
};

const RentalFormTextField = ({
  fieldName,
  label,
  required,
  type,
  control,
}) => {
  const labelClasses = cx(
    styles.label,
    required && styles.required,
  );

  const { field, fieldState: { error } } = useController({
    control,
    name: fieldName,
    rules: {
      required,
    },
  });

  return (
    <div className={styles.field}>
      <label htmlFor={fieldName} className={labelClasses}>
        <span className={styles.content}>
          <span className={styles.title}>
            <span className={styles.text}>
              {label}
            </span>
          </span>
        </span>
      </label>
      <div className={styles.inputGroup}>
        <div className={styles.text}>
          { type === 'phone' ? (
            <InputElement
              className={styles.textInput}
              type="tel"
              mask="(999) 999-9999"
              maskChar=" "
              {...field}
            />
          ) : (
            <input
              className={styles.textInput}
              id={fieldName}
              {...field}
            />
          )}
        </div>
      </div>
      <div className={styles.messageContainer}>
        {error && (
        <div className={styles.message}>
          {error.message}
        </div>
        )}
      </div>
    </div>
  );
};

RentalFormTextField.propTypes = propTypes;
RentalFormTextField.defaultProps = defaultProps;

export default RentalFormTextField;
